import React from 'react';
import { ProgramEnrollmentStatus } from '@sandtech-hub-monorepo/ehub-client';
import { Check, CircleX } from 'lucide-react';

type ProgramEnrollmentStatusProps = {
  status: ProgramEnrollmentStatus;
};

export const ProgramEnrollmentStatusLabel = ({
  status,
}: ProgramEnrollmentStatusProps) => {
  return (
    <>
      {status === 'GRADUATED' && (
        <div className="flex gap-0.5 items-center mr-auto">
          <Check width={24} height={24} className="stroke-success" />
          <span className="text-sm text-success">Completed</span>
        </div>
      )}
      {status === 'FAILED' && (
        <div className="flex gap-1 items-center mr-auto">
          <CircleX className="h-4 w-4 stroke-destructive" />
          <span className="text-sm text-destructive">Withdrawn</span>
        </div>
      )}
    </>
  );
};
